export default __webpack_public_path__ + "static/media/image.529e1b96.png";